var map = {
	"./video-full-icon.png": "2269",
	"./video-pause-icon.png": "90ee",
	"./video-play-icon.png": "1f79",
	"./video-poster.png": "df7ce",
	"./video-refresh.png": "186a",
	"./video-scale-icon.png": "cb41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc69";